<template>
  <div class="createProrram">

      <EditorHeader
          :can-send="$auth.hasPerms('program:info:send')"
          @back="back"
          @clear="emptyAllCanvns"
          @restore="restoreSize"
          @fullscreen="fullscreen"
          @save="saveProgram"
          @send="sendProgram"
      />
      <ProgramCanvas
          ref="programCanvas"
          :back-url="backUrl"
          :zoom="zoom"
          :components-list="componentsList"
          :dels="dels"
          :loaded-images="loadedImages"
          @drag="onDrag"
          @resize="onResize"
          @activated="onActivated"
          @activate-tab="activateTab"
          @image-load="onImageLoad"
          @image-error="onImageError"
      />
      <EditorControlPanel
          ref="controlPanel"
          :active-tab.sync="activeTab"
          :show-bg.sync="showBg"
          :dynamic-tabs.sync="dynamicTabs"
          :task-name="taskName"
          :task-play-mode.sync="taskPlayMode"
          :start-data.sync="startData"
          :end-data.sync="endData"
          :start-time.sync="startTime"
          :end-time.sync="endTime"
          :is-active1.sync="isActive1"
          :is-active2.sync="isActive2"
          :is-active3.sync="isActive3"
          :is-active4.sync="isActive4"
          :is-active5.sync="isActive5"
          :is-active6.sync="isActive6"
          :is-active7.sync="isActive7"
          :min-date="minDate"
          :max-date="maxDate"
          @tab-swap="swapTabs"
          @add-control="addTabWithContent"
          @remove-tab="onRemoveTab"
          @activate-control="activateControlByIndex"
          @clear-bg="clearBg"
          @toggle-week="onToggleWeek"
      />
      <van-overlay :show="show1">
        <div style="height: 100%;display: flex;justify-content: center;align-items: center">
          <van-loading  size="40px" vertical >{{$t('append_field.loadinga')}}</van-loading>
        </div>
      </van-overlay>
      <!--  设备列表弹窗  -->
      <DeviceSelectDialog
          class="device-list"
          v-model="dialogDeviceList"
          :title="$t('append_field.deviceList')"
          :beforeClose="vBeforeClose"
          :pageSize="10"
          :fetchGroups="fetchDeviceGroups"
          :fetchDevices="fetchDeviceList"
          :initialOnlineState="state"
          :initialClientName="clientName"
          :initialGroupParentId="groupParentId"
          @confirm="onDeviceDialogConfirm"
          @confirm-empty="onDeviceDialogConfirmEmpty"
          @cancel="closeDeviceList"
      />

  </div>
</template>
<script>
import qs from 'qs'
import {mapActions, mapState} from 'vuex'
import {Dialog, Toast} from 'vant'
import {vBeforeClose} from "@/utils/tool";
import DeviceSelectDialog from '@/components/DeviceSelectDialog.vue'
import $auth from "@/utils/auth";
import EditorHeader from "@/views/program-editor/components/EditorHeader.vue";
import ProgramCanvas from "@/views/program-editor/components/ProgramCanvas.vue";
import EditorControlPanel from "@/views/program-editor/components/EditorControlPanel.vue";

export default {
  name: 'createProrram',
  inject: ['reload'],
  data() {
    return {
      pmId: this.$route.query.id,
      mainResolutionW: 0,
      mainResolutionH: 0,
      zoom: 1,
      show1: false,
      type: 'add',
      prmgremMsg: [],
      width: 0,
      height: 0,
      loadedImages: {}, // 存储图片加载状态
      minDate:new Date(2024,0,1),
      maxDate:new Date(2100,10,5),
      activeTab: 0,
      dynamicTabs:[],
      taskPlayMode:'1',
      taskId:'',
      taskName:'',
      startData: this.$t('append_field.selectStartDates'),
      endData: this.$t('append_field.selectEndDates'),
      startTime: '00:00:00',
      endTime: '23:59:00',
      isActive1: true,
      isActive2: true,
      isActive3: true,
      isActive4: true,
      isActive5: true,
      isActive6: true,
      isActive7: true,
      showBg:false,//背景的页签显示
      dialogDeviceList:false, //
      activeNames: '',
      terminalSelect: [],
      index: 0,
      newId:0,
      dialogShow:false,
      clientName:'',
      state: '0',
      groupParentId:1,
    }
  },
  mounted() {
    this.width = document.getElementById('canvas').offsetWidth
    this.$nextTick(() => {
      document.getElementById('canvas').style.height = `${this.width}px`
    })
  },
  created() {
    // 初始化节目信息 和pc端不同，这里获取的是任务的信息
    let taskDetailData=this.$route.query.taskDetailData

    const cache = sessionStorage.getItem('taskDetailData')
    taskDetailData = JSON.parse(cache)

    // 设置类型
    if (this.$route.query.type) {
      this.type = this.$route.query.type
    }
    const hasTaskDetail = Array.isArray(taskDetailData) && taskDetailData.length > 0

    if(this.type==='edit' && hasTaskDetail){
      this.taskId=taskDetailData[0].id
      this.taskName = taskDetailData[0].etName
      this.taskPlayMode=taskDetailData[0].etLevel?taskDetailData[0].etLevel: 1
      let now = new Date()
      let nextYear = new Date(new Date().setFullYear(now.getFullYear() + 1))
      this.startData =taskDetailData[0].etStartDate?taskDetailData[0].etStartDate: this.formatter(now)
      this.endData = taskDetailData[0].etEndDate?taskDetailData[0].etEndDate: this.formatter(nextYear)
      this.startTime= taskDetailData[0].etStartTime?taskDetailData[0].etStartTime:'00:00:00'
      this.endTime= taskDetailData[0].etEndTime?taskDetailData[0].etEndTime:'23:59:00'
      this.isActive1 = taskDetailData[0].etMon !== 'false'
      this.isActive2 = taskDetailData[0].etTue !== 'false'
      this.isActive3 = taskDetailData[0].etWed !== 'false'
      this.isActive4 = taskDetailData[0].etThur !== 'false'
      this.isActive5 = taskDetailData[0].etFri !== 'false'
      this.isActive6 = taskDetailData[0].etSat !== 'false'
      this.isActive7 = taskDetailData[0].etSun !== 'false'
    }else {
      this.taskId = this.$route.query.taskId
      this.taskName = this.$route.query.taskName
      let now = new Date()
      let nextYear = new Date(new Date().setFullYear(now.getFullYear() + 1))
      this.startData = this.formatter(now)
      this.endData =  this.formatter(nextYear)
    }

    this.selectPhoneProgramMould()
  },
  methods: {
    vBeforeClose,
    ...mapActions(['addControl', 'addSubtitle', 'emptyCanvns', 'addBackground']),
    fetchDeviceGroups() {
      return this.$ajax.post('/etv/selectDeviceTree.json').then(res => {
        if (res.data.code === 0) {
          return res.data.data[0].children
        }
        Toast(res.data.msg)
        return []
      })
    },

    fetchDeviceList({ onlineState, clientName, groupParentId }) {
      return this.$ajax.post('/etv/searchMobileDeviceTree.json', qs.stringify({
        onlineState,
        clientName,
        groupParentId,
      })).then(res => {
        if (res.data.code === 0) {
          return res.data.data
        }
        Toast(res.data.msg)
        return []
      })
    },

    onDeviceDialogConfirmEmpty() {
      Toast(this.$t('append_field.selectDevice'))
    },

    onDeviceDialogConfirm(payload) {
      this.terminalSelect = payload.terminalSelect
      this.state = payload.onlineState
      this.clientName = payload.clientName
      this.groupParentId = payload.groupParentId
      this.confirmSend()
    },
    selectPhoneProgramMould(){
      // 请求数据 画布中的控件
      this.$ajax.post('/etv/selectPhoneProgramMould.json', qs.stringify({
        pmId: this.pmId,
      })).then(res => {
        if (res.data.code === 0) {
          document.title = this.$t('append_field.create_program')
          const resolution = res.data.data.pmResolution?res.data.data.pmResolution:this.pmResolution(res.data.data.pmFixedScreen)
          this.mainResolutionW = parseInt(resolution.split('*')[0])
          this.mainResolutionH = parseInt(resolution.split('*')[1])
          this.getZoom()
          this.$store.state.componentsList = res.data.data.sceneList[0].componentsList
          const isHttpUrl = res.data.data.sceneList[0].scBackImg.startsWith("http")
          if (isHttpUrl) {
            this.$store.state.backUrl = res.data.data.sceneList[0].scBackImg
          }else {
            this.$store.state.backUrl = this.upFileUrl + res.data.data.sceneList[0].scBackImg
          }

          if(res.data.data.sceneList[0].scBackImg!==''){
            this.showBg = true
          }
          this.$store.state.sceneList = res.data.data.sceneList[0]
          this.componentsList.map(res => {
            res.infoX = res.coLeftPosition
            res.infoY = res.coRightPosition
            res.infoWidth = res.coWidth
            res.infoHeight = res.coHeight
          })
          this.prmgremMsg = [res.data.data]
          this.dynamicTabs = res.data.data.sceneList[0].componentsList.map((tab) => ({
            id: tab.id,
            title: this.dynamicTitle(tab.coType),
            content: tab.coType
          }));
          this.newId=this.dynamicTabs.length
          this.$nextTick(() => {
            // 默认选中第一个动态控件页签（勿用负数，否则 tabIndex→controlIndex 换算失真）
            this.activeTab = this.showBg ? 2 : 1
            this.$refs.controlPanel?.refreshSortable()
          });
        }
      })
    },
    pmResolution(type){
      if (type === 1) {
        return '1920*1080'
      } else if (type === 2) {
        return '1080*1920'
      }
    },
    addTabWithContent(content) {
      if (content === 'background') {
        this.showBg = true
        // 与 showBg 同 tick 更新，避免子组件 showBg watcher 重建 tabs 时 activeTab 仍为旧值
        this.activeTab = 1
        return
      }

      const id = (function f() {
        const arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't']
        let str = ''
        for (let i = 0; i < 12; i++) {
          str += arr[Math.floor(Math.random() * arr.length)]
        }
        return str
      })()
      this.dynamicTabs.push({ id, content })
      this.addControl(content)
      const controlIndex = this.componentsList.length - 1
      this.newId = this.dynamicTabs.length
      this.$nextTick(() => {
        this.activeTab = this.controlIndexToTabIndex(controlIndex)
        this.$refs.controlPanel?.scrollToLastTab()
        this.$refs.controlPanel?.refreshSortable()
        this.activateControlByIndex(controlIndex)
      })
    },

    onRemoveTab({ controlIndex, type }) {
      let newActiveTab = this.activeTab
      if (type === 'background') {
        this.clearBg()
        this.showBg = false
        newActiveTab = 0
      } else {
        if (!this.isValidDynamicIndex(controlIndex)) {
          return
        }
        this.componentsList.splice(controlIndex, 1)
        this.dynamicTabs.splice(controlIndex, 1)
        const currentControlIndex = this.getCurrentControlIndex()
        if (currentControlIndex === controlIndex) {
          newActiveTab = Math.max(0, this.activeTab - 1)
        } else if (currentControlIndex > controlIndex) {
          newActiveTab = this.activeTab - 1
        }
        this.newId = this.dynamicTabs.length
      }
      this.activeTab = newActiveTab
      this.$nextTick(() => {
        this.$refs.controlPanel?.bumpTabsStripKey()
        this.$refs.controlPanel?.refreshSortable()
      })
    },

    onToggleWeek(key) {
      const weekMap = {
        '1': 'isActive1',
        '2': 'isActive2',
        '3': 'isActive3',
        '4': 'isActive4',
        '5': 'isActive5',
        '6': 'isActive6',
        '7': 'isActive7',
      }
      const activeKey = weekMap[key]
      if (activeKey) {
        this[activeKey] = !this[activeKey]
      }
    },
    // ========== 标签和控件关联方法（单一换算源：fixedTabCount + tabIndexToControlIndex / controlIndexToTabIndex）==========


    /**
     * 获取当前激活的控件索引
     */
    tabIndexToControlIndex(tabIndex) {
      const t = Number(tabIndex)
      if (Number.isNaN(t) || t < 0) return null
      if (t === 0) return null
      if (this.showBg && t === 1) return null
      const ci = t - this.fixedTabCount
      return this.isValidDynamicIndex(ci) ? ci : null
    },

    /** componentsList 下标 → van-tab 下标 */
    controlIndexToTabIndex(controlIndex) {
      if (!this.isValidDynamicIndex(controlIndex)) {
        return this.fixedTabCount
      }
      return controlIndex + this.fixedTabCount
    },


    /**
     * 根据索引激活控件
     */
    activateControlByIndex(controlIndex) {
      if (!this.isValidDynamicIndex(controlIndex)) {
        console.warn('无效的控件索引:', controlIndex)
        return
      }

      const control = this.componentsList[controlIndex]
      if (!control) {
        console.warn('控件不存在:', controlIndex)
        return
      }

      this.$store.state.controlIndex = controlIndex
      this.$refs.controlPanel?.applySettingsPanel(control.coType)
      this.$root.$emit('activate-control', controlIndex)
    },


    /**
     * 验证动态索引是否有效
     */
    isValidDynamicIndex(index) {
      return index >= 0 && index < this.componentsList.length
    },


    /**
     * 获取当前激活的控件索引
     */
    getCurrentControlIndex() {
      const ci = this.tabIndexToControlIndex(this.activeTab)
      return ci == null ? -1 : ci
    },


    activateTab(newIndex) {
      this.activeTab = newIndex + this.fixedTabCount
    },

    onActivated(index, type) {
      this.$store.state.controlIndex = index
      const tabIndex = this.controlIndexToTabIndex(index)
      if (this.activeTab !== tabIndex) {
        this.activeTab = tabIndex
      } else {
        this.$refs.controlPanel?.applySettingsPanel(type)
      }
      this.$root.$emit('activate-control', index)
    },
    // 页面和控件布局相关方法
    getZoom() {
      if (this.mainResolutionW / this.mainResolutionH > 1) {
        this.zoom = this.mainResolutionW / this.width;
        document.getElementById('image').style.height = this.mainResolutionH / this.zoom +  'px';
      } else {
        document.getElementById('image').style.height = '100%';
        this.zoom = this.mainResolutionH / this.width
        document.getElementById('image').style.width = this.mainResolutionW / this.zoom + 'px';
      }

    },
    onResize(x, y, width, height) {
      this.componentsList[this.controlIndex].coHeight = height * this.zoom;
      this.componentsList[this.controlIndex].coWidth = width * this.zoom;
      this.componentsList[this.controlIndex].coLeftPosition = x * this.zoom;
      this.componentsList[this.controlIndex].coRightPosition = y * this.zoom;
    },
    onDrag(x, y) {
      this.componentsList[this.controlIndex].coLeftPosition = x * this.zoom;
      this.componentsList[this.controlIndex].coRightPosition = y * this.zoom;
    },
    // 背景相关方法
    clearBg() {
      this.$store.state.backUrl = ''
      this.addBackground({})
    },

    back() {
      this.dialogShow=true
      Dialog.confirm({
        title: this.$t('append_field.exit'),
        message: this.$t('append_field.confirm_leave_page'),
      }).then(() => {
        this.$router.push({path: '/program', query: {itemName: 'a'}})

      })
    },
    emptyAllCanvns(){
      if(this.componentsList.length < 1) return
      Dialog.confirm({
        title: this.$t('append_field.del_title'),
        message: this.$t('append_field.del_message'),
      }).then(() => {
        //清空画布，重置参数
        this.emptyCanvns()
        this.clearBg()
        this.dynamicTabs=[]
        this.showBg = false
        this.newId=0

      })

    },
    saveProgram() {
      this.submit(() => {})
    },
    sendProgram() {
      this.submit(this.getTerinalList)
    },
    // 数据提交相关方法
    submit(callback) {
      this.state='0'
      this.clientName=''
      this.updateEquipmentTask()
          .then(() => {
            let obj = {
              backImg: this.sceneList.scBackImg || "",
              backImgId: this.sceneList.scBackImgId || "",
              backImgSize: this.sceneList.scBackimgSize || "",
              pmId: this.sceneList.scPmId,
              scTime: this.sceneList.scTime,
              sort: this.sceneList.scSort,
              scId: this.sceneList.id,
              scName: this.sceneList.scName,
              type: this.type,
              html: 'hello word',
              isSaveBtn: true,
            };
            let compents = []
            let data = this.componentsList.filter(res => {
              return !this.dels.includes(res.id)
            });
            for (let i = 0; i < data.length; i++) {
              let materials = []
              if (['subtitle', 'webPage', 'streaming', 'hdmin'].includes(data[i].coType)) {
                data[i].txList.forEach(res => {
                  if (res.taContent === '' && data[i].coType!=='hdmin') {
                    Toast(this.$t('append_field.add_content_to_control'));
                    return
                  }
                  materials.push({
                    'color': res.taColor, // 颜色
                    'content': res.taContent, // 内容
                    'fontSize': res.taFontSize, // 长度
                    'move': res.taMove, // 滚动方向
                    'no': 1, // 序号
                    'alignment': res.taAlignment, // 对齐方式
                    'bgColor': res.taBgColor, // 字幕背景色
                    'moveSpeed': res.taMoveSpeed, // 字幕滚动速度
                    'difference': 2, // 属性控件 字幕、天气、日期等控件
                    'address': '', // 地址
                    'countDown': '`',
                    "bgImage": '',
                  })
                })
              } else if(['img', 'video', 'mixture', 'doc','audio'].includes(data[i].coType)){
                data[i].mpList.forEach(res => {
                  materials.push({
                    mtId: res.mid,
                    playParam: res.playParam,
                    difference: '1',
                    cartoon: res.cartoon,
                    vol: res.volume,
                    suffix:res.suffix
                  })
                })
              }else if(['date', 'weeks', 'time'].includes(data[i].coType)){
                data[i].txList.forEach(res => {
                  materials.push({
                    'color': res.taColor, // 颜色
                    'content': res.taContent, // 内容
                    'fontSize': res.taFontSize, // 长度
                    'move': res.taMove, // 滚动方向
                    'no': 1, // 序号
                    'alignment': res.taAlignment, // 对齐方式
                    'bgColor': res.taBgColor, // 字幕背景色
                    'moveSpeed': res.taMoveSpeed, // 字幕滚动速度
                    'difference': 2, // 属性控件 字幕、天气、日期等控件
                    'address': '', // 地址
                    'countDown': '`',
                    "bgImage": '',
                  })
                })
              }

              if (materials.length === 0 && data[i].coType !== 'hdmin') {
                Toast(this.$t('append_field.add_content_to_control'))
                return
              }
              compents.push({
                'type': data[i].coType,
                'leftPosition': parseFloat(data[i].coLeftPosition),
                'rightPosition': parseFloat(data[i].coRightPosition),
                'width': data[i].coWidth,
                'height': data[i].coHeight,
                'actionType': '',
                'linkAction': '',
                'screenProtectTime': '10',
                'materials': materials,
              })
            }

            if (compents.length === 0) {
              Toast(this.$t('append_field.add_control'))
              return
            }
            obj.compents = compents
            this.show1 = true
            this.$ajax({
              method: 'post',
              url: '/etv/insertPhoneSceneInfo.json',
              data: obj,
              headers: {
                'content-type': 'application/json',
              },
            }).then(res => {
              if (res.data.code === 0) {
                Toast(this.$t('append_field.save_success'))
                this.show1 = false
                this.$store.state.sceneList.id = res.data.data

                callback && callback(this.getTerinalList)

              } else {
                Toast(res.data.msg)
                this.show1 = false
              }
            })
          })
          .catch(error => {
            Toast(error.message )
          })
    },

    updateEquipmentTask() {
      return new Promise((resolve, reject) => {
        // 创建开始和结束的 Date 对象
        const startDate = new Date(`${this.startData}T${this.startTime}`)
        const endDate = new Date(`${this.endData}T${this.endTime}`)

        // 检查结束日期是否早于开始日期
        if (endDate < startDate) {
          Toast(this.$t('append_field.end_date_earlier_than_start_date'))
          reject(new Error(this.$t('append_field.end_date_earlier_than_start_date')))
          return; // 终止函数执行
        }
        this.$ajax.post('/etv/updateEquipmentTask.json', qs.stringify({
          etName: this.taskName,
          id: this.taskId,
          etStartDate: this.startData,
          etStartTime: this.startTime,
          etEndDate: this.endData,
          etEndTime: this.endTime,
          etState: '1',
          playMode: this.taskPlayMode,
          etPlayMode: this.taskPlayMode,
          etLevel: this.taskPlayMode,
          etEcId: '1',
          etMon: this.isActive1,
          etTue: this.isActive2,
          etWed: this.isActive3,
          etThur: this.isActive4,
          etFri: this.isActive5,
          etSat: this.isActive6,
          etSun: this.isActive7,
        })).then(res => {
          if (res.data.code === 0) {
            Toast(res.data.msg)
            resolve()
          } else {
            reject(new Error(res.data.msg))
          }
        })
      })
    },
    // 全屏相关方法
    getActiveDraggable() {
      const refName = 'draggable' + this.controlIndex
      const ref = this.$refs[refName]
      return Array.isArray(ref) ? ref[0] : ref
    },
    fullscreen() {
      const draggable = this.getActiveDraggable()
      if (!draggable || typeof draggable.fillParent !== 'function') {
        Toast(this.$t('append_field.add_control'))
        return
      }
      draggable.fillParent()
    },
    restoreSize(){
      const draggable = this.getActiveDraggable()
      if (!draggable || typeof draggable.restoreSize !== 'function') {
        Toast(this.$t('append_field.add_control'))
        return
      }
      draggable.restoreSize()

    },

    onImageLoad(controlId, subIndex) {
      const key = String(controlId)
      if (!this.loadedImages[key]) {
        this.$set(this.loadedImages, key, {})
      }
      this.$set(this.loadedImages[key], subIndex, true)
    },
    onImageError(controlId, subIndex) {
      const key = String(controlId)
      if (!this.loadedImages[key]) {
        this.$set(this.loadedImages, key, {})
      }
      this.$set(this.loadedImages[key], subIndex, false)
    },


    formatter(date) {
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
    },
    // 动态标签页标题相关方法
    dynamicTitle(content) {
      const titleMap = {
        'img': this.$t('append_field.image'),
        'video': this.$t('append_field.control_video'),
        'audio': this.$t('append_field.audio'),
        'mixture': this.$t('append_field.mixture'),
        'doc': this.$t('append_field.document'),
        'date': this.$t('append_field.date'),
        'weeks': this.$t('append_field.weeks'),
        'time': this.$t('append_field.time'),
        'webPage': this.$t('append_field.webPage'),
        'streaming': this.$t('append_field.media'),
        'subtitle': this.$t('append_field.subtitle'),
        'background': this.$t('append_field.control_addbackground'),
        'hdmin': 'HDMI-IN',

      };
      return titleMap[content] || content
    },

    //设备列表
    confirmSend() {
      if (this.terminalSelect.length == 0) {
        Toast(this.$t('append_field.selectDevice'))
        return
      }
      let _this = this
      let postData = {
        ceEtId: _this.taskId,
        clientIdList: '',
      }
      let terminalSelectedArr = _this.terminalSelect
      let noArr = [], idArr = []
      for (var i = 0; i < terminalSelectedArr.length; i++) {
        idArr.push(terminalSelectedArr[i].split('-')[1])
        noArr.push(terminalSelectedArr[i].split('-')[0])
      }

      postData.clientIdList = idArr
      this.$ajax.post('/etv/insertClientEqTask.json', postData).then(res => {
        if (res.data.code == 0) {
          Toast(this.$t('append_field.sendTaskSuccess'))
          _this.isVisible4 = false
          _this.terminalSelect = []
          _this.activeNames = ['1']
          _this.taskId = ''
          _this.$router.push({path: '/program', query: {itemName: 'c'}})
        } else {
          Toast(res.data.msg)
        }


      })
    },
    getTerinalList() {
      this.dialogDeviceList = true
      this.state = '0'
      this.clientName = ''
    },





    closeDeviceList() {
      this.terminalSelect = [] // 清空选择
    },




    /**
     * 交换控件数据和标签顺序
     */
    swapTabs(fromControlIndex, toControlIndex) {

      // 验证索引有效性
      if (!this.isValidDynamicIndex(fromControlIndex) || !this.isValidDynamicIndex(toControlIndex)) {
        console.warn('无效的交换索引:', { from: fromControlIndex, to: toControlIndex })
        return
      }

      // 获取当前激活的控件索引
      const currentControlIndex = this.getCurrentControlIndex()

      // 同步交换页签元数据与控件数据（须同一套 from/to 下标）
      const nextTabs = this.dynamicTabs.slice()
      const tabItem = nextTabs[fromControlIndex]
      nextTabs.splice(fromControlIndex, 1)
      nextTabs.splice(toControlIndex, 0, tabItem)
      this.dynamicTabs = nextTabs

      const nextComponents = this.componentsList.slice()
      const compItem = nextComponents[fromControlIndex]
      nextComponents.splice(fromControlIndex, 1)
      nextComponents.splice(toControlIndex, 0, compItem)
      this.$store.state.componentsList = nextComponents
      if (this.sceneList && this.sceneList.componentsList) {
        this.$store.state.sceneList = {
          ...this.sceneList,
          componentsList: nextComponents,
        }
      }

      // loadedImages 按控件 id 索引，交换顺序不影响

      this.updateActiveTabAfterSwap(currentControlIndex, fromControlIndex, toControlIndex)

      const panel = this.$refs.controlPanel
      panel?.bumpTabsStripKey()
      this.$nextTick(() => {
        panel?.refreshSortable()
        const ci = this.getCurrentControlIndex()
        if (ci >= 0) {
          this.activateControlByIndex(ci)
        }
      })


    },


    /**
     * 交换后更新activeTab索引
     */
    updateActiveTabAfterSwap(currentControlIndex, fromControlIndex, toControlIndex) {
      let newActiveTab = this.activeTab

      if (currentControlIndex === fromControlIndex) {
        // 当前激活的控件是被拖拽的控件
        newActiveTab = toControlIndex + this.fixedTabCount
      } else if (currentControlIndex === toControlIndex) {
        // 当前激活的控件是被拖拽目标位置的控件
        newActiveTab = fromControlIndex + this.fixedTabCount
      } else if (currentControlIndex > fromControlIndex && currentControlIndex <= toControlIndex) {
        // 当前激活的控件在拖拽区间内，需要向后移动
        newActiveTab = this.activeTab - 1
      } else if (currentControlIndex < fromControlIndex && currentControlIndex >= toControlIndex) {
        // 当前激活的控件在拖拽区间内，需要向前移动
        newActiveTab = this.activeTab + 1
      }

      this.activeTab = newActiveTab

    },


  },
  computed: {
    $auth() {
      return $auth
    },
    ...mapState({
      controlIndex: state => state.controlIndex,
      componentsList: state => state.componentsList,
      sceneList: state => state.sceneList,
      backUrl: state => state.backUrl,
      dels: state => state.dels,
    }),
    /** 固定前缀页签数：节目(1) + 可选背景(1)。tab 下标与 componentsList 下标换算均依赖此值 */
    fixedTabCount() {
      return this.showBg ? 2 : 1
    },
  },
  components: {
    EditorControlPanel,
    EditorHeader,
    ProgramCanvas,
    DeviceSelectDialog,
  },
}
</script>

<style scoped lang="scss">


.createProrram {
  height: 100%;
  .van-button--small {
    min-width: 10px !important;
  }



  .canvas {
    background-color: #131212;
    width: 100%;
    //height: 200px;
    display: flex;
    justify-content: center;
    align-items: center; /* 垂直居中 */
    box-sizing: border-box;
  }
  .control-wrapper {
    position: absolute;
    width: 100%;
    background: #ffffff;
    overflow-x: hidden; /* 隐藏水平滚动条 */
    white-space: nowrap; /* 防止控件换行 */
    left: 0;
  }

  .container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
  }

  .header {
    display: flex;
    width: 100%;
    height: 50px;
    position: relative;

  }

  .playMode-content{
    //font-size:  16px;
    padding:10px;
    height: calc(100% - 60px);
    overflow-y: auto;
    .list{
      margin-bottom: 20px;
      .photo {
        box-sizing: border-box;
        padding: 5px;

        .updata-centnt {
          width: 100%;
          height: 100%;
          border-radius: 5px;

          .updata {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            background: #ffffff;

            .updata-img {
              width: 40%;
              height: 40%;
              margin-bottom: 10px;
            }
          }
        }
      }
    }
    .cell-title {
      height: 30px;
      line-height: 30px;
    }
    .progremList {
      overflow-y: auto;
      background: #fff;
      .van-radio{
        overflow: initial;
      }
      .van-radio-group--horizontal{
        display: flex;
        flex-wrap: nowrap;
        flex-direction: row;
      }
    }
    .van-row {
      .van-col {
        display: flex;
        align-items: center;
        flex-direction: column;
        height: 40px;
      }
    }
    .weekliWrap {
      display: flex;
      margin: 10px 0;
      justify-content: space-around;
      position: relative;

      .coverWrap {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        z-index: 10;
      }

      .weekli {
        width: 40px;
        height: 40px;
        background: #fff;
        border: 1px solid #006EFF;
        color: #006EFF;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .weekli.active {
        background: #006EFF;
        color: #fff;
      }
    }
  }
  .overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    .wrapper {
      padding: 0 16px;
      border-radius: 10px;
      display: flex;
      flex-wrap: wrap;
      justify-content: left;
      gap: 10px;
      max-width: 100%;
      max-height: 50%;
    }

    .icon-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: calc(25% - 10px); /* 25% width minus gap to fit 4 items in a row */
      box-sizing: border-box;
      text-align: center;
    }
    .overlay-text{
      max-width: 79px;
      white-space: nowrap; /* 确保文本在一行显示 */
      overflow: hidden; /* 超出容器部分隐藏 */
      text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
    }
    .van-icon {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    span {
      margin-top: 10px;
      display: inline-block;
      white-space: nowrap; /* Prevent text from wrapping */
      color: #FFFFFF;
    }
  }

  .tabs-container {
    flex: 1;
    overflow-x: auto;

  }


  #image {
    background: #ffffff;
    position: relative;
    width: 100%;
  }

  .resizable-content {
    overflow: hidden;
    width: 100%;
    height: 100%;

    .img-content {
      width: 100%;
      height: 100%;
    }

    .text-content {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      white-space:pre-wrap;
    }

  }
}
</style>
